import { Base } from "../../framework/base";
import { FileAttachment, IFileAttachment } from "../common/fileAttachment";
import { EnumHelper, InstantMessageReadState } from "../enums";
import { Translations } from "../translations";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IInstantMessageListItemData {
    id: string;
    channelId: string;
    content: string;
    readState: InstantMessageReadState;
    rowId: string;
    modifyUser: IModifyUser;
    deleteUser: IModifyUser;
    attachments: IFileAttachment[];
    replyToInstantMessage: IInstantMessageListItemData;
}

export interface IInstantMessageListItem extends IInstantMessageListItemData {
    isTitle: boolean;
    replyToInstantMessage: IInstantMessageListItem;

    isNew(): boolean;
    isDeleted(): boolean;
    isNotRead(): boolean;
    isSomeRead(): boolean;
    isAllRead(): boolean
    isUserRead(): boolean
    getHash(): string;
    getText(userCode: string): string;
}

export class InstantMessageListItem implements IInstantMessageListItem {
    id: string;
    channelId: string;
    content: string;
    readState: InstantMessageReadState;
    rowId: string;
    modifyUser: ModifyUser;
    deleteUser: ModifyUser;
    attachments: FileAttachment[];
    replyToInstantMessage: InstantMessageListItem;

    isTitle: boolean;

    constructor();
    constructor(obj: IInstantMessageListItem);
    constructor(obj: IInstantMessageListItemData);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.channelId = obj && obj.channelId || "";
        this.content = obj && obj.content || "";
        this.readState = obj && obj.readState || InstantMessageReadState.NotRead;
        this.rowId = obj && obj.rowId || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.deleteUser = obj && obj.deleteUser ? new ModifyUser(obj.deleteUser) : null;
        this.attachments = Base.getTypedArray<FileAttachment>(obj ? obj.attachments : null, FileAttachment);
        this.replyToInstantMessage = null;
        if (obj && obj.replyToInstantMessage) {
            this.replyToInstantMessage = new InstantMessageListItem(obj.replyToInstantMessage);
        }
        this.isTitle = obj && obj.isTitle || false;
    }

    isNew(): boolean {
        return !this.rowId;
    }

    isDeleted(): boolean {
        return !!this.deleteUser;
    }

    isNotRead(): boolean {
        return EnumHelper.isEqual(this.readState, InstantMessageReadState.NotRead);
    }

    isSomeRead(): boolean {
        return EnumHelper.isEqual(this.readState, InstantMessageReadState.SomeRead);
    }

    isAllRead(): boolean {
        return EnumHelper.isEqual(this.readState, InstantMessageReadState.AllRead);
    }

    isUserRead(): boolean {
        return EnumHelper.isEqual(this.readState, InstantMessageReadState.UserRead);
    }

    getHash(): string {
        return this.id + "#" + this.rowId;
    }

    getText(userCode: string): string {
        return this.isDeleted()
            ? (this.deleteUser.code === userCode
                ? Translations.YouDeletedThisMessage
                : (this.modifyUser.code === this.deleteUser.code
                    ? Translations.ThisMessageWasDeleted
                    : String.format(Translations.ThisMessageWasDeletedByInstantMessageChannelAdministrator, this.deleteUser.name)
                )
            )
            : this.content;
    }
        
    static sortInstantMessageListItems(items: IInstantMessageListItem[], column: string, asc: boolean): IInstantMessageListItem[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: IInstantMessageListItem, b: IInstantMessageListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.modifyUser.date, b.modifyUser.date)); });
    }

    static createTitleItem(title: string): IInstantMessageListItem {
        const result = new InstantMessageListItem();
        result.id = Base.getGuid();
        result.isTitle = true;
        result.content = title;
        return result;
    }
}